import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(
  css({
    textAlign: 'center',
    px: ['default', 'default', 'l'],
    py: ['xl', 'xl', 'l'],
    color: 'black',
  }),
);

themeStyles.addBaseStyles('CtaWrapper')(
  css({
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
    gap: 'm',
  }),
);

themeStyles.addBaseStyles('StyledButton')(({ theme }) =>
  css({
    width: '280px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    '&:focus-visible': {
      outline: `solid 4px ${theme.colors.secondary}`,
      outlineOffset: '-4px',
    },
    '&:before': {
      borderRadius: '0px',
    },
  }),
);

themeStyles.addBaseStyles('TextWrapper')(
  css({
    display: 'grid',
    gap: ['xs', 'xs', 'm'],
    mb: ['default', 'default', 'l'],
  }),
);

export default themeStyles;
